<template>
  <div class="pulseWrapper">
    <div class="pulse">
      <img src="@/assets/svg/ardovaLogo.svg" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>